
import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../components/FormikControl/FormikControl';
import { Add, Check, CheckCircle, Edit, FindReplace, Pending, PendingActions } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import notesServices from '../notesServices';
import moment from 'moment';



function NotesGroupForm({data,callBack}) {
    const {AppAlert} = useAlert();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        title:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data._id,
            title:data.title,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        setSavingStatus(true);

        console.log(values);
        
        notesServices.saveGroup(values).then(res=>{
            //console.log(res.msg);
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack()
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }

    const remove = () =>{
        if(data?.id){
            notesServices.remove(data.id).then(res=>{
                AppAlert("Archived");
                setDialogStatus(false);
                callBack()
            })
        }
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-sm my-2 me-2 btn-outline-warning bg-dark" onClick={addNew} ><Add/> Add Group</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="View / Update">
                    <span type="button" className="border text-white ps-2 border-primary  px-0 py-1 w-100" style={{fontSize:20}} onClick={updateData} >
                        {data.title} <Edit/>
                    </span>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogContent>
                                            <div className="row">
                                                <div className="col-md-12 border border-primary">
                                                    <div className="row p-2">
                                                        <FormikControl control="input" formik={formik} type="text" 
                                                            label="Title" name="title" 
                                                            className="col-md-12 col-xs-12 mb-3" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        {data?.id !== undefined && <button className="btn btn-outline-primary float-end me-5" type="button" onClick={remove}>Archive</button> }
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}
    

export default NotesGroupForm